var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#535353"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4282 39.819H14.5723V16.1809H41.4282V39.819ZM15.6912 38.7001H40.3093V17.2998H15.6912V38.7001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2472 18.8945H32.8489V20.0134H34.2472V18.8945Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7533 18.8945H35.355V20.0134H36.7533V18.8945Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2585 18.8945H37.8601V20.0134H39.2585V18.8945Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1905 23.1126H15.1316V21.9932H18.7273L19.9857 20.7348H26.1593L27.2832 21.8586H40.8686V22.9775H26.8194L25.6956 21.8537H20.4494L19.1905 23.1126Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9529 34.8601L32.1621 34.0687L35.3077 30.9231L32.1621 27.7769L32.9529 26.9861L36.8904 30.9231L32.9529 34.8601Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0469 34.8601L19.1094 30.9231L23.0469 26.9861L23.8377 27.7769L20.692 30.9231L23.8377 34.0687L23.0469 34.8601Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0537 25.5117L24.3623 35.873L25.3816 36.3346L30.073 25.9733L29.0537 25.5117Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0327 32.7114H27.9707V33.8303H29.0327V32.7114Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1206 32.7114H30.0586V33.8303H31.1206V32.7114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware);
export default __webpack_public_path__ + "static/media/software.68a5aad6606393a645825020bd62a165.svg";
export { ForwardRef as ReactComponent };